function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(-0.25)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.891,20.5h-.938a.7.7,0,1,0,0,1.406h.938a.7.7,0,0,0,0-1.406Z",
  transform: "translate(-1.312 -1.28)",
  fill: "#39a95e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.891,20.5H.953a.7.7,0,0,0,0,1.406h.938a.7.7,0,0,0,0-1.406Z",
  transform: "translate(0 -1.28)",
  fill: "#39a95e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.719,17.973a.233.233,0,0,1-.156.22A2.576,2.576,0,0,0,9,19.753a.233.233,0,0,1-.22.156H5.328a.7.7,0,0,0,0,1.406H8.783a.233.233,0,0,1,.22.156,2.561,2.561,0,0,0,4.838,0,.233.233,0,0,1,.22-.156h3.455a.7.7,0,0,0,0-1.406H14.061a.233.233,0,0,1-.22-.156,2.574,2.574,0,0,0-1.56-1.56.233.233,0,0,1-.156-.22V16.848a.234.234,0,0,1,.227-.234c4.594-.15,8.211-1.762,8.211-3.734V11.268a.234.234,0,0,0-.383-.182c-1.816,1.479-5.239,2.259-8.524,2.259s-6.7-.78-8.524-2.259a.234.234,0,0,0-.383.182v1.609c0,1.906,3.375,3.475,7.748,3.715a.233.233,0,0,1,.221.233Zm1.875,2.639a1.172,1.172,0,1,1-1.172-1.172,1.172,1.172,0,0,1,1.172,1.172Z",
  transform: "translate(-0.156 -0.689)",
  fill: "#39a95e"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.657,12.127c4.918,0,8.907-1.678,8.907-3.75V6.768a.234.234,0,0,0-.383-.181c-1.816,1.479-5.238,2.259-8.523,2.259s-6.7-.781-8.525-2.26a.234.234,0,0,0-.383.182v1.61C2.75,10.449,6.735,12.127,11.657,12.127Z",
  transform: "translate(-0.156 -0.408)",
  fill: "#39a95e"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 8.907,
  cy: 3.75,
  rx: 8.907,
  ry: 3.75,
  transform: "translate(2.595)",
  fill: "#39a95e"
}));

var SvgBackendDeveloper = function SvgBackendDeveloper(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22.032,
    height: 22.5,
    viewBox: "0 0 22.032 22.5",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBackendDeveloper, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/backend_developer.9a424036.svg";
export { ForwardRef as ReactComponent };